var render = function render(){var _vm=this,_c=_vm._self._c;return _c('panel-template',{scopedSlots:_vm._u([{key:"bradcrumbs",fn:function(){return [_c('ui-breadcrumbs',{attrs:{"design":"full","container":false},scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('span',[_vm._v("Home")]),_vm._v(" • "),_c('span',[_vm._v("OpenSearch")])]},proxy:true}])})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }